import ParameterFieldBase, { IValidator } from './ParameterFieldBase';
import EditComponent, { INumberFieldOptions } from '../tsx/NumberField';
import { validators as Validators } from './validators';

export default class NumberField extends ParameterFieldBase<INumberFieldOptions> {
    public static EditComponent = EditComponent;

    constructor(glob, title: string, validators?: IValidator[], defaultVal: number = 0, options?: INumberFieldOptions) {
        super(
            glob,
            title,
            options?.allowNull ? undefined : [Validators.number.shouldBe],
            validators,
            defaultVal,
            options
        );
    }
}
